export enum Format {
  HTML = 'HTML',
  PDF = 'PDF',
}

export enum TypeLabel {
  HYBRID = 'HYBRID',
  PAPER = 'PAPER',
  OPEN = 'OPEN',
  USER_GENERATED = 'USER_GENERATED',
}

export type CommentaryBase = {
  author: string | undefined;
  commentaryId: string;
  title: string;
  format: Format;
  sourceName: string;
  dateHtml: string;
  url: string;
  typeLabel: TypeLabel;
};

export interface PaperCommentary extends CommentaryBase {
  typeLabel: TypeLabel.PAPER;
}

export interface HybridCommentary extends CommentaryBase {
  typeLabel: TypeLabel.HYBRID;
}

export interface OpenCommentary extends CommentaryBase {
  typeLabel: TypeLabel.OPEN;
}

export interface UserCommentary extends CommentaryBase {
  id: string;
  typeLabel: TypeLabel.USER_GENERATED;
}

export type Commentary = PaperCommentary | HybridCommentary | OpenCommentary;
export type WebCommentary = OpenCommentary | UserCommentary;
